import { getsertUsuario } from '../services/dbService';
import config from '../config.json';
import { desencriptar, encriptar } from '../utils/netlifyUtils';

export async function getOrCreateUsuario() {
  const key = config.localStorage.idUsuarioEncrypted;
  const encrypted = localStorage.getItem(key);

  if (!encrypted) {
    const user = await getsertUsuario(null, null);
    localStorage.setItem(key, await encriptar(user._id.toString()));
    return user;
  }

  try {
    const id = await desencriptar(encrypted);
    const user = await getsertUsuario(id, null);
    localStorage.setItem(key, await encriptar(user._id.toString()));
    return user;
  } catch {
    const user = await getsertUsuario(null, null);
    localStorage.setItem(key, await encriptar(user._id.toString()));
    return user;
  }
}

export function getSeccionByCodigo (secciones, codigo, codigoPadre = null){
    const seccion = secciones.find(x => x.codigo === codigo);
    const auxTituloPadre = (codigoPadre ? codigoPadre + " - " : "");
    if (seccion){
        return { seccion: seccion, tituloCompuesto: auxTituloPadre + seccion.titulo };
    } else {
        let subseccionEncontrada = null;
        let tituloCompuesto = "";
        for (let i = 0; i < secciones.length; i++){
            if (secciones[i].secciones){
                const { seccion: subseccionEncontradaAux, tituloCompuesto: tituloCompuestoAux } = getSeccionByCodigo(secciones[i].secciones, codigo, auxTituloPadre + secciones[i].titulo)
                if (subseccionEncontradaAux){
                    subseccionEncontrada = subseccionEncontradaAux;
                    tituloCompuesto = tituloCompuestoAux;
                    break;
                }
            }
        }
        return { seccion: subseccionEncontrada, tituloCompuesto };
    }
}

export function extraerTituloCompuesto (titulo) {
    const indice = titulo.lastIndexOf(" - ");
    return indice > -1 ? { seccionesPadre: titulo.substring(0, indice), titulo: titulo.substring(indice + 3) } : { seccionesPadre: "", titulo };
}

export function getSeccionesConContenido(secciones, seccionesConContenido = [], codigoPadre = null){
    const auxTituloPadre = (codigoPadre ? codigoPadre + " - " : "");
    secciones.forEach(seccion => {
        if (seccion.secciones){
            getSeccionesConContenido(seccion.secciones, seccionesConContenido, auxTituloPadre + seccion.titulo)
        } else {
            seccionesConContenido.push({ codigoSeccion: seccion.codigo, tituloCompuesto: auxTituloPadre + seccion.titulo });
        }
    });
    if (!codigoPadre){
        return seccionesConContenido;
    }
}

export function getSeccionesAntAndSig(seccionesContenido, codigo){
    const index = seccionesContenido.findIndex(x => x.codigoSeccion === codigo);
    return { seccionContenidoAnt: index > 0 ? seccionesContenido[index - 1] : null, seccionContenidoSig: index < seccionesContenido.length - 1 ? seccionesContenido[index + 1] : null };
}